class CartIconBubble extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('[aria-controls="cart-drawer"]');
    this.cartDrawer = document.querySelector('cart-drawer');

    if (this.cartDrawer) {
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    this.cartDrawer.drawer.classList.contains(this.cartDrawer.activeClass)
    ? this.cartDrawer.close()
    : this.cartDrawer.open();
  }

  update() {
    fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
    .then((response) => response.json())
    .then((parsedState) => {
      let newHtml = new DOMParser()
        .parseFromString(parsedState['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section').innerHTML;
      document.querySelector('.cart-icon-bubble').innerHTML = newHtml
    })
  }
}

if (!customElements.get('cart-icon-bubble')) {
  customElements.define('cart-icon-bubble', CartIconBubble);
}


